import React from 'react'
import { useSelector } from 'react-redux'
import { Checkbox, Form, Grid, Message } from 'semantic-ui-react'

export const ItemDependencies = ({ translate,invoiceId,merchandiseId,isFormDisabled }) => {
  let choices = [
    { label: 'RELATIONSHIP', value: 'H1' },
    { label: 'RESTRICTION', value: 'H4' },
    { label: 'CONDITIONAL', value: 'H5' },
    { label: 'ARRANGEMENT', value: 'I1' }
  ]
  
  const partyDependency = useSelector((state) => {
    return state.ValueBuildUpReducer.shipmentInvoice
      .find((c) => c.invoiceId === invoiceId)
      ?.merchandise?.find((a) => a.merchandiseId === merchandiseId)})?.partyDependency?.split(',') || []
      
  return (
    <Form.Group className='float-container mg-t-15' widths='equal'>

      <div
        style={{
          textTransform: 'uppercase',
          display: 'flex',
        }}
      >
        <div>
          <strong>{translate('DEPENDENCIES', { ns: ['default', 'lineItem'] })}</strong>
        </div>
      </div>
      <Message style={{ marginTop: '-2px' }}>
        <Grid.Row style={{ justifyContents: 'space-evenly' }}>
          {choices.map(({label, value}) => (
            <Grid.Column width='4' style={{marginRight:'20px'}}>
              <Checkbox
                disabled={isFormDisabled}
                label={<label>{translate(label, { ns: ['default', 'lineItem'] })}</label>}
                checked={partyDependency.includes(value)}
              />
            </Grid.Column>
          ))}
        </Grid.Row>
      </Message>
    </Form.Group>
  )
}
